import { __awaiter } from "tslib";
function run() {
    $(() => {
        const $email = $('#email');
        const $password = $('#password');
        const $domain = $('#domain');
        const $btnSubmit = $('#saveBtn');
        $email.on('keyup', (e) => {
            console.log(e.key, e.which);
            if (e.key === 'Enter') {
                $password.trigger('focus');
            }
        });
        $password.on('keyup', (e) => {
            console.log(e.key, e.which);
            if (e.key === 'Enter') {
                $btnSubmit.trigger('click');
            }
        });
        $btnSubmit.on('click', (e) => __awaiter(this, void 0, void 0, function* () {
            e.preventDefault();
            const credentials = { email: $email.val(), password: $password.val(), domain: $domain.val() };
            $btnSubmit.prop('disabled', true);
            try {
                const res = yield Loading.await(api.post('/setup', credentials));
                const handleRes = ({ success, refresh, redirect }) => {
                    if (redirect)
                        location.href = redirect;
                    if (refresh)
                        location.reload();
                    if (success) {
                        console.log('success!');
                    }
                };
                return (res.msg) ? modalService.msg(res.msg).onClose(() => handleRes(res)) : handleRes(res);
            }
            catch (err) {
                console.error(err);
                modalService.error(err);
            }
            finally {
                $btnSubmit.prop('disabled', false);
            }
        }));
    });
}
export const page_setup = {
    requiresAuth: false,
    run: run,
};
//# sourceMappingURL=setup.js.map